"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = void 0;
const bridge_1 = require("../bridge");
const callBridge = (0, bridge_1.getCallBridge)();
const navigate = async (location) => {
    if (typeof location === 'string') {
        return callBridge('navigate', { url: location, type: 'same-tab' });
    }
    else {
        if (!(location === null || location === void 0 ? void 0 : location.target)) {
            throw new Error('target is required for navigation');
        }
        return callBridge('navigate', { ...location, type: 'same-tab' });
    }
};
const open = async (location) => {
    if (typeof location === 'string') {
        return callBridge('navigate', { url: location, type: 'new-tab' });
    }
    else {
        if (!(location === null || location === void 0 ? void 0 : location.target)) {
            throw new Error('target is required for navigation');
        }
        return callBridge('navigate', { ...location, type: 'new-tab' });
    }
};
const reload = async () => callBridge('reload');
exports.router = {
    navigate,
    open,
    reload
};
